import React, { useState, useEffect } from 'react';
import { callExternalApi } from "../services/external-api.service";
import SettledWindowTransactionsContext from "../contexts/settled-window-transactions-context";

// Component that provides the context value and handles state updates
function SettledWindowTransactionsProvider({ children }) {
  const [settledWindowTransactionsData, setTransactions] = useState([]);
  const [isLoadingSettledWindowTransactionsData, setIsLoading] = useState(true);

  useEffect(() => {
    const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;
    const fetchData = async () => {
      try {
        const config = {
          url: `${tlogApiServerUrl}/api/get-bids/current-window-settled`,
          method: "GET",
          headers: {"content-type": "application/json",},
        };
        
        const { data, error } = await callExternalApi({ config });
        if (data) {
            setTransactions(data);
        } else {
            console.error('Error fetching settled window transactions:', error);
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching settled window transactions:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <SettledWindowTransactionsContext.Provider value={{ settledWindowTransactionsData, isLoadingSettledWindowTransactionsData }}>
      {children}
    </SettledWindowTransactionsContext.Provider>
  );
}

export default SettledWindowTransactionsProvider;